import axios from 'axios';
import { logoutUser } from '../../redux/actions/authActions'
import { store } from '../../redux/store';


const logoutAction = () => {
  store.dispatch(logoutUser());
  window.history.replaceState({}, "", "/");
};

const _exception_handler = (error) => {
  console.error("API Error:", error);
  if (error.response?.status === 401) {
    logoutAction();
  }
  throw error;
};

export const apiCalls = {
  Authentication: {
    authenticateUser: async (username, password) => {
      try {
        const api = axios.create({
          baseURL: process.env.REACT_APP_API_LINK,
          headers: {
            "Content-Type": "application/json",
          },
        });
        const response = await api.post(`Auth`, {
          username: username,
          password: password,
        });
        return response.data;
      } catch (error) {
        _exception_handler(error);
        throw error; 
      }
    },
    ssoLogin: async (token) => {
      try {
        const api = axios.create({
          baseURL: process.env.REACT_APP_API_LINK,
          headers: {
            "Content-Type": "application/json",
          },
        });
        const response = await api.get(`Auth/sso-login`, {
          params:
          {
            token: token,
          }
        });
        return response.data;
      } catch (error) {
        _exception_handler(error);
        throw error; 
      }
    },
  },
};